<template src="./index.html"></template>
<script>
import ywkm from "./ywkm/index.vue";
import {getdata} from "./data.js";
import config from "../../../../../configHttp.js";
import {
  mappingrulepage,
  companysPage,
  saveMappingRule,
  delMappingRule,
  mappingrulefuncgetById,
  updateMappingRule,
  copyMappingRule
} from "../../../../api/home.js";
export default {
  name: "MappingRules",
  components: {
    ywkm,
  },
  data: function () {
    return {
      tablekey: 0,
      overlength: 0,
      // 表格相关
      searchdata: getdata().searchdata,
      searchlist: getdata().searchlist,
      searchdiag: false,
      outlist: [],
      headData: getdata().headData,
      pagination: getdata().pagination,
      tableData: [],
      sort: "",
      order: "",
      //表单
      title: "新增映射规则编码",
      formlist: getdata().formlist,
      formdata: getdata().formdata,
      paginationcompany: getdata().paginationcompany,
      headDatacompany: getdata().headDatacompany,
      tableDatacompany: [],
      removeCompanyList:[],
      shaidiag: false,
      ysdiag: false,
      companydiag: false,
      tableDataAdd: [],
      queryWord: "",
      headDataAdd: getdata().headDataAdd,
      ywdiag: false,
      //科目规则
      kmid: "",
      kmnum: "",
    };
  },
  mounted() {},
  created() {
    this.mappingrulepage();
  },
  methods: {	  geOoverLength(e){
		  this.overlength = e;
		 
	  },
    // 表格
    sortchange(data) {
      this.sort = data.prop;
      this.order = data.order == "ascending" ? "asc" : "desc";
      this.mappingrulepage();
    },
    sizechange(e) {
      this.pagination.pageSize = e;
      this.mappingrulepage();
    },
    currentChange(e) {
      this.pagination.pageNum = e;
      this.mappingrulepage();
    },
    submitSearch() {
      this.pagination.pageNum = 1;
      this.pagination.paginationkey++;
      this.mappingrulepage();
    },
    mappingrulepage() {
      let params = JSON.parse(JSON.stringify(this.searchdata));
      params.current = this.pagination.pageNum;
      params.size = this.pagination.pageSize;
      params.sort = this.sort;
      params.order = this.order;
      mappingrulepage(params).then((res) => {
        this.pagination.total = res.data.data.total;
        this.tableData = res.data.data.records;
      });
    },
    //表单相关
    foraddgzbm() {
      Object.keys(this.formdata).map((key) => (this.formdata[key] = ""));
      this.title = "新增映射规则编码";
      this.ysdiag = true;
      this.$nextTick(() => {
        this.$refs.taxform.clearValidate();
      });
      //清除关联公司
      this.tableDatacompany = [];
      this.removeCompanyList = [];
    },
    forupdatebm(row) {
      mappingrulefuncgetById({
        id: row.id,
      }).then((res) => {
        if (res.data.code == 1) {
          this.formdata = res.data.data.mappingRule;
          this.tableDatacompany = res.data.data.companyRelation;
          this.title = "编辑映射规则编码";
          this.ysdiag = true;
          this.$nextTick(() => {
            this.$refs.taxform.clearValidate();
          });
        }
      });
    },
    foraddcompany() {
      let params = {
        queryWord: this.queryWord,
      };
      params.current = this.paginationcompany.pageNum;
      params.size = this.paginationcompany.pageSize;
      companysPage(params).then((res) => {
        this.tableDataAdd = res.data.data.records;
        this.paginationcompany.total = res.data.data.total;
        this.companydiag = true;
      });
    },
    sizechangecompany(e) {
      this.paginationcompany.pageSize = e;
      this.foraddcompany();
    },
    currentChangecompany(e) {
      this.paginationcompany.pageNum = e;
      this.foraddcompany();
    },
    forseach() {
      this.paginationcompany.paginationkey++;
      this.paginationcompany.pageNum = "1";
      this.foraddcompany();
    },
    savecompany() {
      var chooseitem = this.$refs.tableboxAdd.getSelectionval();
      if (this.$emptyandnull(chooseitem)) {
        this.$message.error("请选择数据");
        return false;
      }
      chooseitem.forEach((item) => {
        if (!this.tableDatacompany.map((gtem) => gtem.id).includes(item.id)) {
          this.tableDatacompany.push(item);
        }
      });
      if(this.removeCompanyList.length>0){
          this.removeCompanyList = this.removeCompanyList.filter(
            (removeItem) => !chooseitem.map((gtem) => gtem.id).includes(removeItem.id)
          );
        }
      this.companydiag = false;
    },
    submitform() {
      this.$refs.taxform.submitForm();
    },
    deletecompany() {
      var chooseitem = this.$refs.tableboxdelete.getSelectionval();
      if (this.$emptyandnull(chooseitem)) {
        this.$message.error("请选择数据");
        return false;
      }
      this.tableDatacompany = this.tableDatacompany.filter(
        (item) => !chooseitem.map((gtem) => gtem.id).includes(item.id)
      );
      chooseitem.forEach( (item) =>{
        this.removeCompanyList.push(item);
      })
    },
    getdata(form) {
      let params = {
        mappingRule: {
          companyNames: this.tableDatacompany.length ==0 ?"":this.tableDatacompany.map((item) => {
            return item.nsrmc;
          }).join(","),
          ruleNum: form.ruleNum,
          defaultFlag: form.defaultFlag,
          description: form.description,
          id: form.id || "",
        },
        companyRelation: this.tableDatacompany.length ==0 ?[]:this.tableDatacompany.map((item) => item.id),
        removeCompanyRelation: this.removeCompanyList.length ==0 ?[]:this.removeCompanyList.map((item) => item.id),
      };
      //如果为默认，则清除所选的公司列表
      if ("1" == form.defaultFlag) {
        params.mappingRule.companyNames = "";
        params.companyRelation = [];
      }
      if (this.title == "新增映射规则编码") {
        saveMappingRule(params).then((res) => {
          if (res.data.code == 1) {
            this.ysdiag = false;
            this.$message.success("新增成功");
            this.mappingrulepage();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      } else {
        updateMappingRule(params).then((res) => {
          if (res.data.code == 1) {
            this.ysdiag = false;
            this.$message.success("编辑成功");
            this.mappingrulepage();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      }
    },
    fordelete() {
      var chooseitem = this.$refs.tablebox.getSelectionval();
      if (this.$emptyandnull(chooseitem)) {
        this.$message.error("请选择要删除的数据");
        return false;
      }
      let params = {
        ids: chooseitem.map((item) => item.id).join(","),
      };
      this.$showConfirm({
        message: "确认删除?",
      }).then((res) => {
        if (res == "confirm") {
          delMappingRule(params).then((res) => {
            if (res.data.code == 1) {
              this.$message.success("删除成功");
              this.paginationcompany.paginationkey++;
              this.paginationcompany.pageNum = "1";
              this.mappingrulepage();
            } else {
              this.$message.error(res.data.msg);
            }
          });
        }
      });
    },
    // 科目规则
    opengz(e) {
      this.ywdiag = true;
      this.kmid = e.id;
      this.kmnum = e.ruleNum;
    },
    // other
    forUpdateSearch() {
      this.searchdiag = true;
    },
    closeSearch() {
      this.searchdiag = false;
    },
    saveChange(e) {
      this.searchdiag = false;
    },
    confirmfilter(e) {
      this.headData = e.chooselist;
      this.outlist = e.nochooselist;
      this.shaidiag = false;
    },
    closeshaidiag() {
      this.shaidiag = false;
    },
    exportExcel() {
      //得到勾选的列表值：
      var chooseitem = this.$refs.tablebox.getSelectionval();
      if(!this.$emptyandnull(chooseitem)){
          this.searchdata.ids = chooseitem.map((item) => item.id).join(",")
      }
      let params = {
        downUrl: config.baseURL + "/mapping-rulefunc/exportExcel",
        typeObj: {
          toForm: true,
          fileType: "xlsx",
          failUrl:this.$winURl
        },
        params: JSON.parse(JSON.stringify(this.searchdata)),
      };
      this.$downloadcommon(params);
    },
    //复制规则
    copyRules(row){
        this.$showConfirm({
        message: "确认复制该规则?",
      }).then((res) => {
		  if (res == "confirm") {
			  let params= {id:row.id}
			copyMappingRule(params).then((res) => {
			  if (res.data.code == 1) {
				  this.$message.success("复制成功");
				  this.mappingrulepage();
				} else {
				  this.$message.error(res.data.msg);
				}
			});
		  }else{
			   //取消
		  }
      });
    }
    



  },
};
</script>

<style scoped lang="less">
@import url("./index.less");
</style>
